module.exports = __webpack_public_path__ + "img/制御工学1_3.2149b942.png";